import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import './assets/font/font.css'
import {  sysLoading, sysSwiper, sysDialog } from "./components/common"
import ElementUI from 'element-ui'
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.use(sysLoading);
Vue.use(sysSwiper);
Vue.use(sysDialog);


Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js